export default __webpack_public_path__ + "cebd1bb4f914d91bf9f7df4074c4e354.svg";